export const meta = {
  appAlias: 'countdown-timer',
  appName: 'Countdown Timer'
} as const;
